export default __webpack_public_path__ + "static/media/Offline.b7341aca.svg";